import { UnoFee } from "@/features/my-order/features/settlement-management/types";
import { endOfMonth, format } from "date-fns";

interface FullCalendarEvent {
  id: string;
  title: string;
  date: Date | string;
  extendedProps: {
    hasCarriedOver?: boolean;
    isBillingDate?: boolean;
    sortOrder?: number;
  };
}

export const convertToFullCalendarEventType = (
  data: UnoFee
): Partial<FullCalendarEvent> => {
  return {
    id: String(data.id),
    title: data.unoFeeAmount.toLocaleString(),
    date: data.finalCustomsClearanceDate,
    extendedProps: {
      hasCarriedOver: data.isDelayed,
      sortOrder: 1,
    },
  };
};

export const createFullCalendarBillingDateEvent = (
  date: Date
): Partial<FullCalendarEvent> => {
  const lastDayOfMonth = endOfMonth(date);
  const formattedLastDay = format(lastDayOfMonth, "yyyy-MM-dd");
  const month = date.getMonth() + 1;

  return {
    id: lastDayOfMonth + String(month),
    title: `${month}월 청구일`,
    date: formattedLastDay,
    extendedProps: {
      isBillingDate: true,
      sortOrder: 0,
    },
  };
};

export const getEventSortOrder = (event: unknown) => {
  if (!event || typeof event !== "object" || !("extendedProps" in event)) {
    return 1;
  }

  const extendedProps = event.extendedProps as { sortOrder?: unknown };

  return typeof extendedProps.sortOrder === "number"
    ? extendedProps.sortOrder
    : 1;
};
